import { useExternalLinkPreferenceStore } from "@stores/useExternalLinkPreferenceStore";
import { getCachedM365Environment } from "@utils/helpers/environmentHelpers";

const teamsSameWindowDomains = (
	import.meta.env.VITE_TEAMS_SAME_WINDOW_DOMAINS ?? ""
)
	.split(",")
	.map((domain: string) => domain.trim().toLowerCase().replace(/\.$/, ""))
	.filter(Boolean);

function escapeRegExp(value: string) {
	return value.replace(/[|\\{}()[\]^$+?.]/g, "\\$&");
}

/** Matches a hostname against a domain pattern such as `example.com` or `*.example.com`. */
export function matchesDomainPattern(hostname: string, pattern: string) {
	const normalizedHostname = hostname.toLowerCase().replace(/\.$/, "");
	const normalizedPattern = pattern.trim().toLowerCase().replace(/\.$/, "");
	if (!normalizedPattern) return false;

	const expression = escapeRegExp(normalizedPattern).replace(/\*/g, ".*");
	return new RegExp(`^${expression}$`, "i").test(normalizedHostname);
}

export function isTeamsSameWindowUrl(url: URL) {
	return teamsSameWindowDomains.some((pattern: string) =>
		matchesDomainPattern(url.hostname, pattern),
	);
}

export function isExternalUrl(href: string) {
	try {
		const url = new URL(href, window.location.href);
		return (
			(url.protocol === "http:" || url.protocol === "https:") &&
			url.origin !== window.location.origin
		);
	} catch {
		return false;
	}
}

export function openExternalLink(href: string) {
	const destination = new URL(href, window.location.href);
	const url = destination.href;
	const target = useExternalLinkPreferenceStore.getState().target;
	const inTeams = getCachedM365Environment().environment === "Teams";

	if (
		(inTeams && isTeamsSameWindowUrl(destination)) ||
		(!inTeams && target === "current-tab")
	) {
		window.location.assign(url);
		return;
	}

	if (!inTeams && target === "new-window") {
		window.open(
			url,
			"_blank",
			"popup=yes,noopener,noreferrer,width=1200,height=800,resizable=yes,scrollbars=yes",
		);
		return;
	}

	window.open(url, "_blank", "noopener,noreferrer");
}
